import { lexonHttp } from "@/plugins/axios/lexonHttp";

export class MaintenanceService {
  constructor() {}

  getData(url: string) {
    return lexonHttp.get(url)
  }
}
